import {useState} from "react";
import {useQuery} from "react-query";
import axios from "services/axios";

async function getDoctorPrices(id, filter) {
	const {data} = await axios.get(`admin/doctor-prices`, {params: filter});

	return data;
}

export function useDoctorPrices(hospitalId) {
	const [filterPrices, setFilterPrices] = useState({
		hospitalId,
		page: 1,
		search: null,
		limit: 10,
	});
	const fallback = [];
	const {
		data = fallback,
		isLoading,
		isError,
		error,
	} = useQuery(["doctor-prices", hospitalId, filterPrices], async () => getDoctorPrices(null, filterPrices));

	return {data, isLoading, isError, error, filterPrices, setFilterPrices};
}

export const fetchDoctorPriceByID = priceId => {
	return axios.get(`admin/doctor-prices/${priceId}`).then(res => res.data);
};

export function useDetailDoctorPrice(priceId) {
	return useQuery({
		queryKey: priceId && ["doctor-prices", priceId],
		queryFn: key => fetchDoctorPriceByID(priceId),
		refetchOnMount: true,
		refetchOnWindowFocus: true,
		enabled: !!priceId,
	});
}

async function getDoctorPricesPerDoctor(id, filter) {
	const {data} = await axios.get(`admin/doctor-prices/doctor/${id}`, {params: filter});

	return data;
}

export function useDoctorPricesPerDoctor(hospitalId, doctorId) {
	const [filterPrices, setFilterPrices] = useState({
		hospitalId,
		page: 1,
		search: null,
		limit: 10,
	});
	const fallback = [];
	const {
		data = fallback,
		isLoading,
		isError,
		error,
	} = useQuery(["doctor-prices", hospitalId, filterPrices, doctorId], async () =>
		getDoctorPricesPerDoctor(doctorId, filterPrices),
	);

	return {data, isLoading, isError, error, filterPrices, setFilterPrices};
}
